import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Active, ActiveButton } from "../../../../Constant";
import {  ACTIVE_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_ACTIVE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatActiveButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={ActiveButton} span={ACTIVE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn active color="primary" className="btn-square" id="Tooltip-29">{Active}</Btn>
        <ToolTip target="Tooltip-29" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-primary active</ToolTip>
        {FLAT_ACTIVE_BUTTONS_LIST.map((data, index) => (
          <CommonFlateButton key={index} item={data} active={true} />
        ))}
      </CardBody>
    </Card>
  );
};

export default FlatActiveButtons;
